import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const ImageGallery = makeShortcode("ImageGallery");
const ImageGalleryImage = makeShortcode("ImageGalleryImage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Workshops and critique groups have been critical to my growth.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Writing Workshops and Critique Groups</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Makerspace</AnchorLink>
    </AnchorLinks>
    <h2>{`Writing Workshops and Critique Groups`}</h2>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage col={4} alt="Highlights Workshop" title="Highlights Workshop" mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "395px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "32.29166666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8UlEQVQY0wHmARn+ADZrnwwsZJpnL2acajFnnWkxZ51oMWedZzBnnGYtZJtlM2meZTFnnWQxaJ1iNWqfZzdsmTcAAP8Ae6BTBZCwPgOQsD4DkLA+A4+vPQGPrz0AAChhmQ8+caPrVoOu/1+Js/81ap7/Q3Wl/0R1pv9Fdqb/OG2g/z9xo/8yaJ7/LmWa/ylhp3BkjmYAnbogAIiqNQCHqjQAiKo1AI6uPACIqjUAAJ+40QBnj7eyl7LN/46syfiKqcf6kK3K+n+hwvmYs874g6PD+IinxveJqMX2aJC8/2uUb66WtSxziKo6bomrNmCIqjVSiKo1SY6uPCuIqzUAAEV2pgA4bKCIZo62/2aPtvmWss3/kq7L/2WOtv+ZtM7/orrS/2SNtf90mbz/cZa+/5GwZ/+hvEn/nblO/6G8Uf+fu0//nLlM/5KxQMuvxWEAADNpngA1ap5WMGed/y1km/9Gd6f0Q3Wm4yVel9BAc6SzXoiylBxYk3MhXJdUb5dV0pGwRvqbuEnnnLhM4566Tt6duUzWm7hL25GxP6NwmhkBADJonQAyaJ0VM2meXDZrnzwaVpInAkWHEQAAWABmj7YAnbfSABpXjQAaV6IAtcwhI46vMyl9oysed58hFmSRDA47dAAG////AJm2SAAAAAAASMTr6D7OaI8AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Highlights Workshop",
            "title": "Highlights Workshop",
            "src": "/static/5225336fabce5141c23c08f3c625c3e3/e0ffd/highlights-logo.png",
            "srcSet": ["/static/5225336fabce5141c23c08f3c625c3e3/7fc1e/highlights-logo.png 288w", "/static/5225336fabce5141c23c08f3c625c3e3/e0ffd/highlights-logo.png 395w"],
            "sizes": "(max-width: 395px) 100vw, 395px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage col={4} alt="Odyssey Writing Workshop" title="Odyssey Writing Workshop" mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "610px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.15277777777778%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWUlEQVQozz1RzUqcQRD8dldFZF0IrNGgWROi5KCHgK6GGP9WT0KWBARFDCQXCSSGLlEi+CQe8gC+TBfkYbquoXc+PTQzU91V09VdGaMyjxaoJVCHoDqgKlCDUa7cK3iUYDktg/Wbeg7qnbmqqiYfgXoPagjqBagdUGdgtEF1zTUDj1l4PAM1D485K/g0qDfmMQD1LbVSrAvqAoyOMY7N4zuoSzB+groF9RvUNagrUL/AOAd1B+prfm6liSEYn7LrR0uvQbXNNQbGZ1CroE7NYx3UgjGWQb1MopXaH/DoFbujmr/GuEksxd6CmiwRE7VYD9RGbT9J4+YxYa7tnLW5FnNeGaC2QD2A+gfqPoET89H8VkDtgfoI14ck1bbW4Fo3j31Qu+bRB1M4+ubxyhiboL6A+gPq4HEpFVxNoxrZaS7habtUyzwaRrXAaJmrCcZ0wUfOpkoucTX/A/hqTPyPq3iJAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Odyssey Writing Workshop",
            "title": "Odyssey Writing Workshop",
            "src": "/static/c72af2f877fb949016b7fdb9ac41a93e/c718f/odyssey-workshop-logo.png",
            "srcSet": ["/static/c72af2f877fb949016b7fdb9ac41a93e/7fc1e/odyssey-workshop-logo.png 288w", "/static/c72af2f877fb949016b7fdb9ac41a93e/a5df1/odyssey-workshop-logo.png 576w", "/static/c72af2f877fb949016b7fdb9ac41a93e/c718f/odyssey-workshop-logo.png 610w"],
            "sizes": "(max-width: 610px) 100vw, 610px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`My first workshop experience was a lovely week-long program for authors of
Middle-Grade novels at the `}<a parentName="p" {...{
        "href": "https://www.highlightsfoundation.org/upcoming-workshops/"
      }}>{`Highlights Foundation`}</a>{` in Pennsylvania. We each got
feedback on our novel draft from a published, successful author in this space, and we met for informal classes with these authors as well.`}</p>
    <p>{`But in 2013, I got accepted into the `}<a parentName="p" {...{
        "href": "https://www.odysseyworkshop.org/"
      }}>{`Odyssey Writing
Workshop`}</a>{`, an elite six-week “boot camp” in New Hampshire of full-time
writing, classes, and most important of all, `}<em parentName="p">{`critique`}</em>{`. Odyssey introduced me
to the `}<em parentName="p">{`critique circle`}</em>{`, to the exquisite pain and transformative improvements
that come with the feedback, often conflicting, from a whole table of fellow authors.`}</p>
    <p>{`When I went home, I promptly joined a local critique circle of Odyssey almuni,
and we met monthly for critiques for years, almost up until COVID.`}</p>
    <p>{`Even that wasn’t enough for me; I started my own small critique circle in my
little town in rural Virginia.`}</p>
    <h2>{`Makerspace`}</h2>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage col={6} alt="Rochester Makerspace" title="Rochester Makerspace" mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "23.958333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABnxAAAZ8QHYvU0GAAABQklEQVQY012QTUsCYRSFz4jLoiATQitn3ncyxWa8r2Z+IUIaBaEWJQimUiA0c0eJ9tUmghZtomXr/kAQ9Jf6EcYM1aLF4X7AfTjn4utCYnY9j1a1j7fjKnZLIyTI06RytaRyNFO5gZLKwWbOQTw7gU4MqdxAIugZQjEkMRAAvUj4tVNfej8thvOFsQ/EanYSVF8xexrMhn8g7gDM/mA/wJAgNwBj2uigW+stPh02483yMKMTH0nlZhLkFXTyUjpxaS3rbRjEPUE8NIj7BvGZIG4L4pEgPpGKGz7QF3LbYy1mTxdmHA2lc5dzBrFtKtdsVfvpbq1n7VcG1qDeNdrV/tZeeVg7qAzyteI5CWIhlWtK5VpSseFH9t1ixZ4iYl3ho7uDVM4Jlv6PEH0Gll+AxD2ATyD+CJg3wPoDIG//R8avw29iW1k0y44LTgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Rochester Makerspace",
            "title": "Rochester Makerspace",
            "src": "/static/798e6d4ab451b13b528895d2f4b93e3e/3cbba/rocmakers-logo.png",
            "srcSet": ["/static/798e6d4ab451b13b528895d2f4b93e3e/7fc1e/rocmakers-logo.png 288w", "/static/798e6d4ab451b13b528895d2f4b93e3e/a5df1/rocmakers-logo.png 576w", "/static/798e6d4ab451b13b528895d2f4b93e3e/3cbba/rocmakers-logo.png 1152w", "/static/798e6d4ab451b13b528895d2f4b93e3e/0b124/rocmakers-logo.png 1728w", "/static/798e6d4ab451b13b528895d2f4b93e3e/4ea69/rocmakers-logo.png 2304w", "/static/798e6d4ab451b13b528895d2f4b93e3e/2f44c/rocmakers-logo.png 3400w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`Now that I’ve moved to Rochester, NY, I’m delighted to have joined another kind
of workshop, the `}<a parentName="p" {...{
        "href": "https://rocmakers.org/"
      }}>{`Rochester Makerspace`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The Rochester Makerspace provides members with 24/7 access to tools, space, resources, and a community of like-minded makers.`}</p>
    </blockquote>
    <p>{`My kids and I still can’t quite believe that we have full access to so many
incredible tools, from a suite of 3D printers to a laser cutter to a
professional-grade woodworking shop.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      